module.exports = __webpack_public_path__ + "img/flag-en.389d5345.svg";